import { render, staticRenderFns } from "./TarjetaDiasInscripcion.vue?vue&type=template&id=6a19c31c&scoped=true"
import script from "./TarjetaDiasInscripcion.vue?vue&type=script&lang=js"
export * from "./TarjetaDiasInscripcion.vue?vue&type=script&lang=js"
import style0 from "./TarjetaDiasInscripcion.vue?vue&type=style&index=0&id=6a19c31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19c31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
